import { createApp } from 'vue';
import type { Plugin } from 'vue';
import { RouterLink } from 'vue-router';
import { createI18n } from 'vue-i18n';
import { MainPlugin, ConfigurationPlugin } from '@keyvue/one-ui';
import { configureAPIs as configureLegacyAPIs } from '@keyvue/one-api-client-legacy';
import loadSentry from '@/services/sentry/plugins/sentry';
import loadZendesk from '@/services/zendesk/plugins/zendesk';
import EventBus from '@/services/eventbus/plugins/eventbus';
import AppBranding from '@/services/app-branding/plugins/appBranding';
import ApiClient from '@/services/keyvue-api/plugins/apiClient';
import App from '@/App.vue';
import router from '@/services/router/index';
import ConfigurationHelper from '@/services/keyvue-ui/helpers/ConfigurationHelper';
import messages from './global.messages.json';

import '@keyvue/one-ui/dist/style.css';
import 'v-calendar/style.css';
import 'quill/dist/quill.snow.css';

configureLegacyAPIs({
    baseURL: import.meta.env.VITE_LEGACY_HOST,
    basePath: import.meta.env.VITE_LEGACY_BASEPATH,
});

const app = createApp(App);

const i18n = createI18n({
    legacy: false,
    locale: 'nl',
    fallbackLocale: 'en',
    messages,
});

app.use(AppBranding);

app.use(i18n);
app.use(MainPlugin as unknown as Plugin);
app.use(
    ConfigurationPlugin as unknown as Plugin,
    ConfigurationHelper.getThemeConfig(),
    ConfigurationHelper.getStyleConfig(),
    ConfigurationHelper.getFontConfig(),
);

// Event bus as soon as possible, so we can hook into it in all parts of the application
app.use(EventBus);

// Api client before router so we can call the client from global navigation guards
app.use(ApiClient);

// Router with provided router link for use in ui package
app.use(router);
app.provide('router-link', RouterLink);

// Sentry needs to be loaded before the app is mounted
loadSentry(app, router);

// mount
app.mount('#app');

loadZendesk();
